import React from 'react';
import logo from '../../../../assets/logo.png'

const Header = ({...props}) => {

    return (
        <div className={"bg-white flex flex-row align-center justify-between p-4 border-b-2 border-mcia_gray_middle"}>
            <a href=''>
                <img src={logo} className="w-64 m-4" alt={"MyCIA"}/>
            </a>
            <div className="font-bold ml-2">Accounting</div>
        </div>
    );
};

export default Header;
